// extracted by mini-css-extract-plugin
export default {"background":"BridesPageWrapper_background__UAct9"};